import { Component } from '@angular/core';
import { PillarPagesTemp } from '../../components/pillar-pages-temp/pillar-pages-temp';

@Component({
  selector: 'app-epso',
  imports: [PillarPagesTemp],
  templateUrl: './epso.html',
  styleUrl: './epso.scss',
})
export class Epso {

}
